import{a as n}from"./chunk-EI7MMDWY.js";function i(r,t,e){if(r>e)throw new Error("Min value is greater than max value.");if(e<r)throw new Error("Max value is lesser than min value.");return t>e?e:t<r?r:t}n(i,"clamp");export{i as a};
